import { useMemo } from 'react';
export function useBreadcrumbs({
  title,
  pathKey,
  productType,
  backBreadcrumb = false,
  listingSlug
} = {}) {
  return useMemo(() => {
    if (backBreadcrumb) {
      return [{
        pathKey: 'HOME',
        isCurrentPage: false
      }];
    }
    const breadcrumbs = [{
      pathKey: 'HOME'
    }];
    const getProductTypePath = () => ({
      pathKey: productType === 'AGENT' ? 'AGENTS' : 'APPS',
      isCurrentPage: false
    });
    switch (pathKey) {
      case 'FEATURED_COLLECTION':
        return [...breadcrumbs, {
          pathKey: 'FEATURED',
          isCurrentPage: false
        }, {
          pathKey,
          isCurrentPage: true,
          title
        }];
      case 'LISTING_DETAILS':
        return [...breadcrumbs, getProductTypePath(), {
          pathKey,
          isCurrentPage: true,
          title
        }];
      case 'LISTING_REVIEWS':
        return [...breadcrumbs, getProductTypePath(), {
          pathKey: 'LISTING_DETAILS',
          isCurrentPage: false,
          title,
          listingSlug
        }, {
          pathKey,
          isCurrentPage: true
        }];
      default:
        return [...breadcrumbs, {
          pathKey,
          isCurrentPage: true
        }];
    }
  }, [title, pathKey, productType, backBreadcrumb, listingSlug]);
}